<template>
    <div>
        <card>
            <h3 style="margin-top:10px;margin-left:5px">Corso di formazione</h3>
            <hr>
            <form>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="nome">Nome</label>
                        <input type="text" class="form-control" id="nome" v-model="nome" placeholder="nome" readonly>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="docente">Docente</label>
                        <input type="text" class="form-control" id="docente" v-model="docente" placeholder="nome docente" readonly>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="data_corso">Data Corso</label>
                        <input type="date" class="form-control" id="data_corso" v-model="data_corso">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="data_scadenza">Data Scadenza</label>
                        <input type="date" class="form-control" id="data_scadenza" v-model="data_scadenza">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="sede">Sede</label>
                        <input type="text" class="form-control" id="sede" v-model="sede" placeholder="sede" readonly>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="aula">Aula</label>
                        <input type="text" class="form-control" id="aula" v-model="aula" placeholder="nome aula" readonly>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="descrizione">Descrizione</label>
                        <input type="text" class="form-control" id="descrizione" v-model="descrizione" placeholder="descrizione" readonly>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="durata_giorni">Durata (GIORNI)</label>
                        <input type="text" class="form-control" id="durata_giorni" v-model="durata_giorni">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="durata_ore">Durata (ORE)</label>
                        <input type="text" class="form-control" id="durata_ore" v-model="durata_ore">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="giorno_ora">Orario</label>
                        <input type="datetime-local" class="form-control" id="giorno_ora" v-model="giorno_ora">
                    </div>
                    <div class="form-group col-md-1">
                        <!-- <button class="btn" type="button" style="background:#00467f;margin-top:20px"></button> -->
                        <i class="fas fa-plus-circle" style="font-size:35px;margin-top:20px;color:#00467f" v-on:click="addGiornoOra()"></i>
                    </div>
                    <div class="form-group col-md-6">
                        <table class="table tablesorter" id="tabella" style="text-align: center" v-if="giorniOrari.length > 0">
                            <thead>
                                <tr>
                                    <th>GIORNO</th>
                                    <th>ORA</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="row-color" v-for="(valori, index) in giorniOrari" v-bind:key="index">
                                    <td>{{getDate(valori)}}</td>
                                    <td>{{getTime(valori)}}</td>
                                    <td><i class="fa fa-times-circle" style="font-size:25px;color:#00467f" @click="removeGiornoOra(index)"></i></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="codice">Codice</label>
                        <input type="text" class="form-control" v-model="codice" id="codice" readonly>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="codice_tipo">Codice Tipo</label>
                        <input type="text" class="form-control" v-model="codice_tipo" id="tipo" readonly>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="organizzatore_corso">Organizzatore del corso</label>
                        <input type="text" class="form-control" v-model="organizzatore_corso" id="organizzatore_corso">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="finanziato">Corso finanziato</label>
                        <input type="checkbox" class="form-control" v-model="finanziato" id="finanziato">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="importo">Costo</label>
                        <div class="input-icon">
                            <input type="number" class="form-control" v-model="costo" id="costo" placeholder="0.00">
                            <i>€</i>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn float-right" style="background:#00467f" v-on:click="salvaCorso()">Salva</button>
                <!-- <button v-if="user_livello == 1" type="button" class="btn float-left" style="background:#00467f" v-on:click="cancellaCorso()">Cancella Corso</button> -->
            </form>
        </card>

        <card>
            <!-- <hr> -->
            <h3 style="text-decoration: underline;" @click="showCorsisti = !showCorsisti">Corsisti</h3>
            <div v-if="showCorsisti">
                <div class="row" style="justify-content:left;">
                    <!-- <button type="button" class="btn" style="background:#00467f;margin-left:20px" v-on:click="showCreaCorsista = !showCreaCorsista">Crea corsista</button> -->
                </div>
                <div v-if="showCreaCorsista">
                    <form>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="nome_corsista">Nome</label>
                                <input type="text" class="form-control" id="nome_corsista" v-model="nome_corsista" placeholder="nome corsista">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="cognome_corsista">Cognome</label>
                                <input type="text" class="form-control" id="cognome_corsista" v-model="cognome_corsista">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="nome_azienda">Nome azienda</label> 
                                <input type="text" class="form-control" id="nome_azienda" v-model="nome_azienda" placeholder="nome azienda">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="cellulare_corsista">Telefono Cellulare</label>
                                <input type="text" class="form-control" id="cellulare_corsista" v-model="cellulare_corsista">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="ufficio_corsista">Telefono Ufficio</label>
                                <input type="text" class="form-control" id="ufficio_corsista" v-model="ufficio_corsista">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="fax_corsista">Fax</label>
                                <input type="text" class="form-control" id="fax_corsista" v-model="fax_corsista">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="email_corsista">Indirizzo Email</label>
                                <input type="text" class="form-control" id="email_corsista" v-model="email_corsista">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="mansione_corsista">Mansione</label>
                                <input type="text" class="form-control" id="mansione_corsista" v-model="mansione_corsista" placeholder="mansione corsista">
                            </div>
                            <!-- <div class="form-group col-md-4">
                                <label for="non_chiamare">Non chiamare</label>
                                <input type="checkbox" class="form-control" id="non_chiamare" v-model="non_chiamare">
                            </div> -->
                        </div>
                        <!-- <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="assegnato_a">Assegnato a</label>
                                <input type="text" class="form-control" v-model="assegnato_a" id="assegnato_a">
                            </div>
                        </div> -->
                        <div class="form-row">
                            
                        </div>
                        <button type="button" class="btn float-right" style="background:#00467f" v-on:click="salvaCorsista()">Salva</button>
                    </form>
                </div>
                <table class="table tablesorter" style="text-align: center">
                    <thead>
                        <tr>
                            <th>NOME</th>
                            <th>NOME AZIENDA</th>
                            <th>EMAIL</th>
                            <th>TELEFONO UFFICIO</th>
                            <!-- <th></th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="row-color" v-for="valori in carica_corsisti" v-bind:key="valori.ID"><!--   -->
                            <td>{{valori.first_name}} {{valori.last_name}}</td>
                            <td>{{valori.azienda}}</td>
                            <td></td>
                            <td>{{valori.phone_work}}</td>
                            <td></td>
                            <!-- <td><router-link :to="'/modifica-corsista?idCorso='+idCorso+'&idCorsista='+idCorsista"><i class="tim-icons icon-pencil" style="color:#00467f"></i></router-link></td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </card>
        <card>
            <!-- <hr> -->
            <h3 @click="showAziende = !showAziende" style="text-decoration: underline;">Aziende</h3>
            <div  v-if="showAziende">
                <div class="row">
                    <div class="col">
                        <button type="button" class="btn" style="background:#00467f;float:left;" v-on:click="showCreaAzienda = !showCreaAzienda">Crea azienda</button>
                    </div>
                    <div class="col">
                        <!-- <button @click="modals.mini = true" class="btn" type="button" style="float:right;background:#00467f;">Cerca Azienda</button> -->
                    </div>
                </div>
                <div v-if="showCreaAzienda">
                    <form>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="ragione_sociale">Ragione Sociale</label>
                                <input type="text" class="form-control" id="ragione_sociale" v-model="a_ragione_sociale">
                            </div>
                            <div class="form-group col-md-6"></div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="sito_web">Sito web</label>
                                <input type="text" class="form-control" id="sito_web" v-model="a_sito_web">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="telefono_azienda">Telefono</label>
                                <input type="text" class="form-control" id="telefono_azienda" v-model="a_telefono_">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="email_azienda">Indirizzi Email</label>
                                <input type="text" class="form-control" id="email_azienda" v-model="a_email">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="fax_azienda">Fax</label>
                                <input type="text" class="form-control" id="fax_azienda" v-model="a_fax">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="settore_azienda">Settore</label>
                                <input type="text" class="form-control" id="settore_azienda" v-model="a_settore">
                            </div>
                            <div class="form-group col-md-4">
                                <label for="tipo_azienda">Tipo</label>
                                <select v-model="a_tipo" class="form-control">
                                    <option></option>
                                </select>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                                <label for="assegnato_azienda">Assegnato a</label>
                                <input type="text" class="form-control" id="assegnato_azienda" v-model="a_assegnato">
                            </div>
                            <div class="form-group col-md-6"> </div>
                        </div>
                        <button type="button" class="btn float-right" style="background:#00467f" v-on:click="salvaAzienda()">Salva</button>
                    </form>
                </div>
                <table class="table tablesorter" style="text-align: center">
                    <thead>
                        <tr>
                            <th>NOME</th>
                            <th>CITTÀ</th>
                            <th>TELEFONO</th>
                            <th>EMAIL</th>
                            <!-- <th></th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="row-color" v-for="valori in carica_aziende" v-bind:key="valori.ID"><!--  -->
                            <td>{{valori.name}}</td>
                            <td>{{valori.billing_address_city}}</td>
                            <td>{{valori.phone_office}}</td>
                            <td></td>
                            <!-- <td><router-link :to="'/modifica-nota?id='"><i class="tim-icons icon-pencil" style="color:#00467f"></i></router-link></td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </card>
        
        <!-- MODAL PER CERCARE AZIENDE-->
        <modal :show.sync="modals.mini"
                :show-close="false"
                header-classes="justify-content-center"
                type="mini"
                style="position:fixed;overflow: auto;"><!--vertical-align: middle;overflow: auto; transform: translateY(-40%) -->
            <div class="modal-profile d-flex">
                <button class="btn float-left" @click="modals.mini = false" style="background:#00467f;"><i class="tim-icons icon-simple-remove" ></i></button>
            </div>
            <label for="cerca_azienda"><strong>NOME AZIENDA </strong></label>
            <input class="form-control" type="text" placeholder="Nome azienda" name="cerca_azienda" v-model="cerca_azienda" v-on:change="cercaInfo()">
            <label for="cerca_codice_fiscale"><strong>CODICE FISCALE </strong></label>
            <input class="form-control" type="text" placeholder="Codice fiscale" name="cerca_codice_fiscale" v-model="cerca_codice_fiscale" v-on:change="cercaInfo()">
            <label for="cerca_p_iva"><strong>PARTITA IVA</strong></label>
            <input class="form-control" type="text" placeholder="Partita iva" name="cerca_p_iva" v-model="cerca_p_iva" v-on:change="cercaInfo()">
            <template slot="footer">
            <!-- tabella con i risultati -->
            <div v-show="showRisultati">
                <div v-if="cerca_info.length>0">
                <table class="table tablesorter" style="text-align: center;">
                    <thead>
                    <tr>
                        <th>AZIENDA</th>
                        <th>CF</th>
                        <th>P. IVA</th>
                        <th>SEDE</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(valori,index) in cerca_info" v-bind:key="valori.ID">
                        <td style="text-decoration:underline"><a v-on:click="compilaForm(index)">{{valori.name}}</a></td>
                        <td>{{valori.crm_cf_c}}</td>
                        <td>{{valori.crm_piva_c}}</td>
                        <td>{{valori.billing_address_street}}, {{valori.billing_address_city}} ({{valori.billing_address_state}}) {{valori.billing_address_postalcode}}</td><!--infoAzienda.billing_address_street + ", " + infoAzienda.billing_address_city + " (" + infoAzienda.billing_address_state + ") " +infoAzienda.billing_address_postalcode -->
                    </tr>
                    </tbody>
                </table>
                </div>
                <div v-else>
                <div class="text-center" v-if="!nessunRisulato">
                    <!-- <circle-10></circle-10> -->
                </div>
                <div v-else>
                    <p>Nessun risultato trovato</p>
                </div>
                    <!--<p>Nessun risultato trovato</p>-->
                </div>
            </div>
            </template>
        </modal>

        
    </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import {Modal} from '@/components';
import moment from 'moment';
import Services from '@/services/Services';
import CorsoServices from '@/services/CorsoServices';

export default {
    components: {
      Card,
      Modal
    },
  
    data() {
        return {
            modals: {
                mini: false,
                corsisti: false,
            },
            
            carica_corso: [],
            carica_corsisti: [],
            carica_aziende: [],
            file: null,
            showCreaCorsista: false,
            showCreaAzienda: false,
            
            nome: null,
            docente: null,
            data_corso: null,
            data_scadenza: null,
            sede: null,
            aula: null,
            descrizione: null,
            durata_giorni: null, 
            durata_ore: null,
            giorno_ora: null,
            giorniOrari: [],
            codice: null,
            codice_tipo: null,
            finanziato: false,
            organizzatore_corso: null,
            costo: null,
            n_iscritti: null,
            //pop up per cercare 
            showRisultati: false,
            nessunRisulato: false,
            cerca_azienda: '',
            cerca_codice_fiscale: '',
            cerca_p_iva: '',
            cerca_info: [],
            denominazione_search: null,
            codice_fiscale_search: null,
            partita_iva_search: null,
            
            // corsista 
            nome_corsista: null,
            nome_azienda: null,
            cognome_corsista: null, 
            ufficio_corsista: null,
            mansione_corsista: null,
            cellulare_corsista: null,
            fax_corsista: null,
            non_chiamare: false,
            email_corsista: null,
            fonte_lead: null,
            assegnato_a: null,

            // azienda
            a_ragione_sociale: null,
            a_sito_web: null,
            a_telefono: null, 
            a_email: null,
            a_fax: null,
            a_settore: null,
            a_assegnato: null,

            showAziende: false,
            showCorsisti: false,

            idCorso: null,
            showDelete: false,
            confermaCancella: false,
            access_token: null,
            token_response: [],
            urlRichieste: 'https://sviluppoallergeni.confcom.it/'   //'https://apiintranet.confcom.it/'
        }
    },
    methods: {
        addGiornoOra: function() {
            if (this.giorno_ora != null && this.giorno_ora != '') {
                this.giorniOrari.push(this.giorno_ora);
                this.giorno_ora = "";
            }
        },
        removeGiornoOra: function(index) {
            this.giorniOrari.splice(index, 1);
        },

        cercaInfo: async function() {
            let errore = 0;
            const token = localStorage.getItem('access_token');
            await Services.searchInformation(this.cerca_azienda, this.cerca_codice_fiscale, this.cerca_p_iva)
            // await axios.get(
            // this.urlRichieste + 'azienda?filter=true&name='+this.cerca_azienda+'&CF='+this.cerca_codice_fiscale+'&piva='+this.cerca_p_iva +'&relazioni=true',
            // //'https://sviluppoallergeni.confcom.it/azienda?filter=true&name='+this.cerca_azienda+'&CF='+this.cerca_codice_fiscale+'&piva='+this.cerca_p_iva, 
            // {headers: {
            //     'Content-type': 'application/json',
            //     'Authorization': `Bearer ${token}`
            // }})
            .then(response => { this.cerca_info = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                errore = error.response.status;
                }
            })
            if (errore == 401) {
            let value = await this.refreshToken();
            if (value) { await this.cercaInfo(); }
            }
            this.showRisultati = true;
            if (this.cerca_info.length == 0) {
            this.nessunRisulato = true;
            }
        },

        cancellaCorso: async function() {
            this.showDelete = true;
        },

        confermaCancellaFunction: async function() {
            console.log(`confermaCancellaFunction`);
            let errore = 0;
            this.confermaCancella = false;
            let response_dati = [];
            // await NoteServices.deleteNota(this.idNota)
            await axios.delete(
                this.urlRichieste + '../' + this.idCorso,
                    {
                        withCredentials: true,
                        headers: {
                            'Content-type': 'application/json',
                            'Authorization': `Bearer ${this.access_token}`
                        }
                    }
            )
            .then(response => { response_dati = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if(errore == 401){
                let value = await this.refreshToken();
                if (value) { await this.cancellaCorso(); }
            } 
            // this.$router.push({
            //     path: '/corsi'
            // })   
        },

        //se id!=null carica nota
        caricaCorso: async function() {
            let errore = 0;
            // let response_dati = [];
            await CorsoServices.caricaCorso(this.idCorso)
                .then(response => { this.carica_corso = response.data})
                .catch(function (error) {
                    // handle error
                    if(error.response.status == 401){
                        errore = error.response.status;
                    }
                })
            if(errore == 401){
                let value = await this.refreshToken();
                if (value) { await this.caricaCorso(); }
            }
            console.log("corso");
            console.log(this.carica_corso);
            this.nome = this.carica_corso["C_CORSO.NOME"];
            // console.log(`nome: ${this.nome}`);
            this.docente = this.carica_corso.DOCENTE;
            this.data_corso = this.carica_corso.DATA_CORSO;
            // console.log(`data_corso: ${this.data_corso}`);
            this.data_scadenza = this.carica_corso.DATA_SCADENZA;
            this.sede = this.carica_corso["C_AULA.INDIRIZZO"];
            this.aula = this.carica_corso["C_AULA.NOME"];
            this.descrizione = this.carica_corso["C_CORSO.DESCRIZIONE"];
            // console.log(`descr: ${this.descrizione}`);
            this.durata_giorni = this.carica_corso.DURATA_GIORNI;
            // console.log(`durata_g: ${this.durata_giorni}`);
            this.durata_ore = this.carica_corso.DURATA_ORE;
            // console.log(`durata_o: ${this.durata_ore}`);
            this.codice = this.carica_corso.CODICE_CORSO;
            // console.log(`cod corso: ${this.codice}`);
            this.codice_tipo = this.carica_corso["C_CORSO.CODICE_TIPO"];
            // console.log(`cod tipo: ${this.codice_tipo}`);
            this.organizzatore_corso = this.carica_corso.ORGANIZZATORE;
            this.costo = this.carica_corso.COSTO;
            // console.log(`costo: ${this.costo}`);
            if (this.carica_corso.CORSISTI.length > 0) {
                this.carica_corsisti = this.carica_corso.CORSISTI;
                console.log(`corsisti: `);
                console.log(this.carica_corsisti);
            }
            if (this.carica_corso.AZIENDE.length > 0) {
                this.carica_aziende = this.carica_corso.AZIENDE;
                console.log(`aziende: `);
                console.log(this.carica_aziende);
            }

        },

        caricaCorsista: async function() {
            // let dati = [{ CF: this.cf_corsista, NOME: this.nome_corsista, COGNOME: this.cognome_corsista, AZIENDA: this.nome_azienda, CELLULARE: this.cellulare_corsista, EMAIL: this.email_corsista, MANSIONE: this.mansione_corsista }];
            // await CorsoServices.getCorsista()
            // .then(response => { response_dati = response.data })
            // .catch( function (error) {
            //     if (error.response.status == 401) {
            //         errore = error.response.status;
            //     }
            // })
            // if (errore == 401) {
            //     let value = await this.refreshToken();
            //     if (value) { await this.salvaCorsista(); }
            // }
            
        },

        checkData: function() {
            // if () {
            //         return false;
            // } else {
            //     return true;
            // }
        },

        compilaForm: function(index){
            let infoAzienda = this.cerca_info[index];
            this.denominazione = infoAzienda.name;
            this.codice_fiscale = infoAzienda.crm_cf_c;
        },

        logout: async function () {
            await Services.logout()
            .then(response => { this.results = response.data})
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.setItem('isLogged', false);
            localStorage.removeItem('user_nome');
            localStorage.removeItem('user_cognome');
            localStorage.removeItem('user_tipologia');
            localStorage.removeItem('user_email');
            localStorage.removeItem('user_livello');
            localStorage.removeItem('user_id');
            this.$router.push({
            path: '/login'
            })
            // window.location.reload()
        },
        
        modificaCorsista: function() {
            this.nome_corsista = null;
            this.nome_azienda = null;
            this.cognome_corsista = null; 
            this.ufficio_corsista = null;
            this.mansione_corsista = null;
            this.cellulare_corsista = null;
            this.fax_corsista = null;
            this.non_chiamare = false;
            this.email_corsista = null;
            this.fonte_lead = null;
            this.assegnato_a = null;
        },

        modificaAzienda: function() {
            this.a_ragione_sociale = null;
            this.a_sito_web = null;
            this.a_telefono = null; 
            this.a_email = null;
            this.a_fax = null;
            this.a_settore = null;
            this.a_assegnato = null;
        },

        refreshToken: async function() {
            let errore = 0;
            await Services.refreshToken()
            .then(response => { this.token_response = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 403){
                    errore = error.response.status;
                } else if (error.response.status == 401) {
                    errore = error.response.status;
                }
            });
            console.log(`errore fuori da catch refreshToken = ${errore}`);
            if(errore == 403 || errore == 401){
                console.log(`errore = ${errore} -> fai logout`);
                await this.logout();
                return false;
            } 
            localStorage.setItem('access_token', this.token_response.accessToken);
            return true;
        },

        salvaCorso: async function() {
            let id_user = localStorage.getItem('user_id');
            let dati = []; 
            let errore = 0;
            // if (!this.checkData()) {
            //     alert("compilare tutti i dati");
            // } else {
                if (this.idCorso == null || this.idCorso == '') {
                    let response_dati = [];
                    dati.push({ 
                        DATA_CORSO: this.data_corso, DATA_SCADENZA: this.data_scadenza, DURATA_ORE: this.durata_ore, DURATA_GIORNI: this.durata_giorni, COSTO: this.costo, N_ISCRITTI: this.n_iscritti, ORGANIZZATORE: this.organizzatore_corso, FINANZIATO: this.finanziato
                        // NOME: this.nome, DOCENTE: this.docente, DATA_CORSO: this.data_corso, DATA_SCADENZA: this.data_scadenza, SEDE: this.sede, DESCRIZIONE: this.descrizione, DURATA_GIORNI: this.durata_giorni, DURATA_ORE: this.durata_ore, CODICE: this.codice, CODICE_TIPO: this.codice_tipo, COSTO: this.costo 
                    });
                    let datiJSON = JSON.stringify(dati[0]);
                    console.log(dati);
                    console.log(datiJSON);
                    // se null crea nota
                    // await CorsoServices.creaCorso(datiJSON)
                    // .then(response => { response_dati = response.data})
                    // .catch(function (error) {
                    //     // handle error
                    //     if(error.response.status == 401){
                    //         errore = error.response.status;
                    //     }
                    // })
                    // if(errore == 401){
                    //     let value = await this.refreshToken();
                    //     if (value) { await this.salvaValori(); }
                    // }
                    // this.$router.push({
                    //     path: '/corsi'
                    // })
                } else {
                    //se non è null aggiorna
                     if (this.carica_corsisti.length > 0) {
                        this.n_iscritti = this.carica_corsisti.length;
                    }
                    console.log(`n_iscritti: ${this.n_iscritti}`);
                    let response_dati = [];
                    dati.push({ 
                        DATA_CORSO: this.data_corso, DATA_SCADENZA: this.data_scadenza, DURATA_ORE: this.durata_ore, DURATA_GIORNI: this.durata_giorni, COSTO: this.costo, N_ISCRITTI: this.n_iscritti, ORGANIZZATORE: this.organizzatore_corso, FINANZIATO: this.finanziato
                        // NOME: this.nome, DOCENTE: this.docente, DATA_CORSO: this.data_corso, DATA_SCADENZA: this.data_scadenza, SEDE: this.sede, DESCRIZIONE: this.descrizione, DURATA_GIORNI: this.durata_giorni, DURATA_ORE: this.durata_ore, CODICE: this.codice, CODICE_TIPO: this.codice_tipo, COSTO: this.costo 
                    });
                    let datiJSON = JSON.stringify(dati[0]);
                    await CorsoServices.updateCorso(this.idCorso, datiJSON)
                    .then(response => { response_dati = response.data})
                    .catch(function (error) {
                        // handle error
                        if(error.response.status == 401){
                            errore = error.response.status;
                        }
                    })
                    if(errore == 401){
                        let value =  await this.refreshToken();
                        if (value) { await this.salvaValori(); }
                    }
                    this.$router.push({
                        path: '/corsi'
                    })
                }
            // }
        },

        salvaCorsista: async function() {
            //   <!-- nome_corsista cognome_corsista nome_azienda cellulare_corsista ufficio_corsista fax_corsista email_corsista mansione_corsista assegnato_a-->
            let response_dati = [];
            let errore = 0;
            let dati = [{ CF: this.cf_corsista, NOME: this.nome_corsista, COGNOME: this.cognome_corsista, AZIENDA: this.nome_azienda, CELLULARE: this.cellulare_corsista, EMAIL: this.email_corsista, MANSIONE: this.mansione_corsista }];
            // await CorsoServices.creaCorsista()
            // .then(response => { response_dati = response.data })
            // .catch( function (error) {
            //     if (error.response.status == 401) {
            //         errore = error.response.status;
            //     }
            // })
            // if (errore == 401) {
            //     let value = await this.refreshToken();
            //     if (value) { await this.salvaCorsista(); }
            // }
        },

        salvaAzienda: function() {

        },

        main: async function() {
            this.user_livello = localStorage.getItem('user_livello');
            this.idCorso = this.$route.query.id;
            console.log(`idCorso=${this.idCorso}.`);
            this.access_token = localStorage.getItem('access_token');
            axios.defaults.withCredentials = true;
            await this.caricaCorso();
            // try {
            //     // if (this.idCorso != null) {
            //         await this.caricaCorso();
            //     // }
            // } catch (error) {
            //     if (error.response.status == 401) {
            //         await this.refreshToken();
            //     }
            //     console.log(`error --> ${error}`);
            // }  
        },

        getDate(datetime) {
            return moment(String(datetime)).format('DD/MM/YYYY');
        },

        getDateAnnoMeseGiorno(datetime) {
            return moment(String(datetime)).format('YYYY-MM-DD');
        },

        getTime(datetime){
            const myArray = datetime.split("-");
            const arr =  myArray[myArray.length-1].split(":");
            const ora= arr[0].substring(3,5);
            const min = arr[1];
            const time = ora + ":" + min;
            return time;
        },
    },

    mounted() {
        this.main();
    },
    
    beforeMount() {
        
    }
  };
</script>
<style scoped>
/* body {
    margin: 10px; 
     padding: 10px;
} */
form {
    /* max-width: 580px; */
    margin: auto;
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.input-icon {
  position: relative;
}

.input-icon > i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
	font-style: normal;
}

.input-icon > input {
  padding-left: 25px;
padding-right: 0;
}

.input-icon-right > i {
  right: 0;
}

.input-icon-right > input {
  padding-left: 0;
  padding-right: 25px;
  text-align: right;
}

</style>
  